import { HTMLAttributes } from 'react';
import RecordRTC from 'recordrtc';

export interface VideoElementProps extends HTMLAttributes<HTMLVideoElement> {
  style?: any;
  autoPlay?: boolean;
  muted?: boolean;
  loop?: boolean;
  resolution?: RESOLUTION;
  handleMounted?: () => void;
  handlePlay?: () => void;
  handleError?: (e: Error) => void;
}

export type Recorder = {
  stream: MediaStream;

  startRecording(): Promise<void>;
  stopRecording(): Promise<void>;
  getBlob(): Promise<Blob>;
  getDataURL(): Promise<string>;
  destroy(): void;
};

export enum WebcamStatus {
  UNINITIALIZED,
  INACTIVE,
  ACTIVE,
  ERROR,
}

export interface IResolution {
  width: number;
  height: number;
}

export function getResolutionValue(resolution: RESOLUTION): IResolution {
  switch (resolution) {
    case RESOLUTION.QVGA:
      return { width: 320, height: 240 };
    default:
    case RESOLUTION.VGA:
      return { width: 640, height: 480 };
    case RESOLUTION.DVD:
      return { width: 720, height: 480 };
    case RESOLUTION.SVGA:
      return { width: 800, height: 600 };
    case RESOLUTION.HD:
      return { width: 1280, height: 720 };
    case RESOLUTION.FHD:
      return { width: 1920, height: 1080 };
    case RESOLUTION.QHD:
      return { width: 2560, height: 1440 };
    case RESOLUTION.UHD:
      return { width: 3840, height: 2160 };
  }
}

export enum RESOLUTION {
  QVGA,
  VGA,
  DVD,
  SVGA,
  HD,
  FHD,
  QHD,
  UHD,
}

export const DEFAULT_OPTIONS: RecordRTC.Options = {
  mimeType: 'video/webm;codecs=vp9',
  videoBitsPerSecond: 512000,
  audioBitsPerSecond: 128000,
  numberOfAudioChannels: 1,
};
export const DEFAULT_CONSTRAINTS: MediaStreamConstraints = {
  video: { ...getResolutionValue(RESOLUTION.VGA), frameRate: 30 },
  audio: true,
};
